import { transformDataToGAFour } from '@tracking/transforms/googleAnalyticsFour';
import { getCurrentEnvironment } from '@general/env';

// If edited, also edit templates/default_site/_layouts.group/_default_render_web.html
export const gaMeasurementIDs = {
    PRODUCTION_LEGACY: 'UA-5792071-1',
    STAGE_DEV_LEGACY: 'UA-5792071-2',
    GTM: 'GTM-KVC4R8Z',
    GTAG_ADWORDS: 'AW-830177583',
    TESTING_GA4: 'G-DMQ6DMQB54',
    STAGING_GA4: 'G-2KNFLRZHZ5',
    PRODUCTION_GA4: 'G-63559Q508V',
};

export const sendToGAFour = (data, gaMeasurementID) => {
    if (data?.excludeService && data.excludeService.find(val => val === 'GA4')) return;
    const env = getCurrentEnvironment();
    let sendToID = gaMeasurementID;

    if (!sendToID) {
        switch (env) {
            case 'local-dev':
                sendToID = gaMeasurementIDs.TESTING_GA4;
                break;

            case 'stage':
                sendToID = gaMeasurementIDs.PRODUCTION_GA4;
                break;

            case 'production':
                sendToID = gaMeasurementIDs.PRODUCTION_GA4;
                break;

            default:
                sendToID = gaMeasurementIDs.TESTING_GA4;
                break;
        }
    }

    const readyData = transformDataToGAFour(data);
    readyData.send_to = sendToID;

    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', readyData.type, readyData);
        if (data?.user) {
            window.gtag('set', 'user_properties', data.user);
        }
    }
};
